import { usePreference } from "../../../context/usePreference"; 

export function MinuteSecondAudience({ audSh }) {
  const u = usePreference();
  const Indice = u.userPreference?.Indice;

  switch (Indice) {
    case 3:
    case 4:
      return (
        <p
          style={{
            position: "absolute",
            right: "10px",
            marginTop: "-40px",
            color: "#FFFFFF",
            fontSize: "12px",
            opacity: 0.5,
          }}
        >
          {audSh != "-%" ? audSh : <></>}
        </p>
      );
    default:
      return <></>;
  }
}